import common from './common';
import login from './login';
import dashboard from './dashboard';

export default {
    common,
    login,
    dashboard,
};
